import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/holiday-rules',
    name: 'holiday-rule',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/holiday-rule/index.vue')
  }
]
